import DlsPanel from '@collectivehealth/dls-panel';
import { StyleUtilities, getCheckForSlotted } from '@collectivehealth/dls-styles';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-lightbulb.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-check.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-triangle-exclamation.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-circle-x.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-close.js';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

var identity = function identity(x) {
  return x;
};

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

var is_client = typeof window !== 'undefined';
var now = is_client ? function () {
  return window.performance.now();
} : function () {
  return Date.now();
};
var raf = is_client ? function (cb) {
  return requestAnimationFrame(cb);
} : noop; // used internally for testing

var tasks = new Set();

function run_tasks(now) {
  tasks.forEach(function (task) {
    if (!task.c(now)) {
      tasks.delete(task);
      task.f();
    }
  });
  if (tasks.size !== 0) raf(run_tasks);
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */


function loop(callback) {
  var task;
  if (tasks.size === 0) raf(run_tasks);
  return {
    promise: new Promise(function (fulfill) {
      tasks.add(task = {
        c: callback,
        f: fulfill
      });
    }),
    abort: function abort() {
      tasks.delete(task);
    }
  };
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function empty() {
  return text('');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function set_custom_element_data(node, prop, value) {
  if (prop in node) {
    node[prop] = value;
  } else {
    attr(node, prop, value);
  }
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

function custom_event(type, detail) {
  var e = document.createEvent('CustomEvent');
  e.initCustomEvent(type, false, false, detail);
  return e;
}

var HtmlTag =
/*#__PURE__*/
function () {
  function HtmlTag(html) {
    var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, HtmlTag);

    this.e = element('div');
    this.a = anchor;
    this.u(html);
  }

  _createClass(HtmlTag, [{
    key: "m",
    value: function m(target) {
      var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      for (var i = 0; i < this.n.length; i += 1) {
        insert(target, this.n[i], anchor);
      }

      this.t = target;
    }
  }, {
    key: "u",
    value: function u(html) {
      this.e.innerHTML = html;
      this.n = Array.from(this.e.childNodes);
    }
  }, {
    key: "p",
    value: function p(html) {
      this.d();
      this.u(html);
      this.m(this.t, this.a);
    }
  }, {
    key: "d",
    value: function d() {
      this.n.forEach(detach);
    }
  }]);

  return HtmlTag;
}();

var stylesheet;
var active = 0;
var current_rules = {}; // https://github.com/darkskyapp/string-hash/blob/master/index.js

function hash(str) {
  var hash = 5381;
  var i = str.length;

  while (i--) {
    hash = (hash << 5) - hash ^ str.charCodeAt(i);
  }

  return hash >>> 0;
}

function create_rule(node, a, b, duration, delay, ease, fn) {
  var uid = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  var step = 16.666 / duration;
  var keyframes = '{\n';

  for (var p = 0; p <= 1; p += step) {
    var t = a + (b - a) * ease(p);
    keyframes += p * 100 + "%{".concat(fn(t, 1 - t), "}\n");
  }

  var rule = keyframes + "100% {".concat(fn(b, 1 - b), "}\n}");
  var name = "__svelte_".concat(hash(rule), "_").concat(uid);

  if (!current_rules[name]) {
    if (!stylesheet) {
      var style = element('style');
      document.head.appendChild(style);
      stylesheet = style.sheet;
    }

    current_rules[name] = true;
    stylesheet.insertRule("@keyframes ".concat(name, " ").concat(rule), stylesheet.cssRules.length);
  }

  var animation = node.style.animation || '';
  node.style.animation = "".concat(animation ? "".concat(animation, ", ") : "").concat(name, " ").concat(duration, "ms linear ").concat(delay, "ms 1 both");
  active += 1;
  return name;
}

function delete_rule(node, name) {
  node.style.animation = (node.style.animation || '').split(', ').filter(name ? function (anim) {
    return anim.indexOf(name) < 0;
  } // remove specific animation
  : function (anim) {
    return anim.indexOf('__svelte') === -1;
  } // remove all Svelte animations
  ).join(', ');
  if (name && ! --active) clear_rules();
}

function clear_rules() {
  raf(function () {
    if (active) return;
    var i = stylesheet.cssRules.length;

    while (i--) {
      stylesheet.deleteRule(i);
    }

    current_rules = {};
  });
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

function get_current_component() {
  if (!current_component) throw new Error("Function called outside component initialization");
  return current_component;
}

function onDestroy(fn) {
  get_current_component().$$.on_destroy.push(fn);
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function tick() {
  schedule_update();
  return resolved_promise;
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var promise;

function wait() {
  if (!promise) {
    promise = Promise.resolve();
    promise.then(function () {
      promise = null;
    });
  }

  return promise;
}

function dispatch(node, direction, kind) {
  node.dispatchEvent(custom_event("".concat(direction ? 'intro' : 'outro').concat(kind)));
}

var outroing = new Set();
var outros;

function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros // parent group

  };
}

function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }

  outros = outros.p;
}

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

function transition_out(block, local, detach, callback) {
  if (block && block.o) {
    if (outroing.has(block)) return;
    outroing.add(block);
    outros.c.push(function () {
      outroing.delete(block);

      if (callback) {
        if (detach) block.d(1);
        callback();
      }
    });
    block.o(local);
  }
}

var null_transition = {
  duration: 0
};

function create_in_transition(node, fn, params) {
  var config = fn(node, params);
  var running = false;
  var animation_name;
  var task;
  var uid = 0;

  function cleanup() {
    if (animation_name) delete_rule(node, animation_name);
  }

  function go() {
    var _ref = config || null_transition,
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? 0 : _ref$delay,
        _ref$duration = _ref.duration,
        duration = _ref$duration === void 0 ? 300 : _ref$duration,
        _ref$easing = _ref.easing,
        easing = _ref$easing === void 0 ? identity : _ref$easing,
        _ref$tick = _ref.tick,
        tick = _ref$tick === void 0 ? noop : _ref$tick,
        css = _ref.css;

    if (css) animation_name = create_rule(node, 0, 1, duration, delay, easing, css, uid++);
    tick(0, 1);
    var start_time = now() + delay;
    var end_time = start_time + duration;
    if (task) task.abort();
    running = true;
    add_render_callback(function () {
      return dispatch(node, true, 'start');
    });
    task = loop(function (now) {
      if (running) {
        if (now >= end_time) {
          tick(1, 0);
          dispatch(node, true, 'end');
          cleanup();
          return running = false;
        }

        if (now >= start_time) {
          var t = easing((now - start_time) / duration);
          tick(t, 1 - t);
        }
      }

      return running;
    });
  }

  var started = false;
  return {
    start: function start() {
      if (started) return;
      delete_rule(node);

      if (is_function(config)) {
        config = config();
        wait().then(go);
      } else {
        go();
      }
    },
    invalidate: function invalidate() {
      started = false;
    },
    end: function end() {
      if (running) {
        cleanup();
        running = false;
      }
    }
  };
}

function create_out_transition(node, fn, params) {
  var config = fn(node, params);
  var running = true;
  var animation_name;
  var group = outros;
  group.r += 1;

  function go() {
    var _ref2 = config || null_transition,
        _ref2$delay = _ref2.delay,
        delay = _ref2$delay === void 0 ? 0 : _ref2$delay,
        _ref2$duration = _ref2.duration,
        duration = _ref2$duration === void 0 ? 300 : _ref2$duration,
        _ref2$easing = _ref2.easing,
        easing = _ref2$easing === void 0 ? identity : _ref2$easing,
        _ref2$tick = _ref2.tick,
        tick = _ref2$tick === void 0 ? noop : _ref2$tick,
        css = _ref2.css;

    if (css) animation_name = create_rule(node, 1, 0, duration, delay, easing, css);
    var start_time = now() + delay;
    var end_time = start_time + duration;
    add_render_callback(function () {
      return dispatch(node, false, 'start');
    });
    loop(function (now) {
      if (running) {
        if (now >= end_time) {
          tick(0, 1);
          dispatch(node, false, 'end');

          if (! --group.r) {
            // this will result in `end()` being called,
            // so we don't need to clean up here
            run_all(group.c);
          }

          return false;
        }

        if (now >= start_time) {
          var t = easing((now - start_time) / duration);
          tick(1 - t, t);
        }
      }

      return running;
    });
  }

  if (is_function(config)) {
    wait().then(function () {
      // @ts-ignore
      config = config();
      go();
    });
  } else {
    go();
  }

  return {
    end: function end(reset) {
      if (reset && config.tick) {
        config.tick(1, 0);
      }

      if (running) {
        if (animation_name) delete_rule(node, animation_name);
        running = false;
      }
    }
  };
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement =
  /*#__PURE__*/
  function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SvelteElement).call(this));

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

var alertPanel = {
  "dls-typography-desktop-body-reg-medium": "mce6561a28_dls-typography-desktop-body-reg-medium",
  "alertPanel": "mce6561a28_dls-typography-desktop-body-reg-medium mce6561a28_alertPanel",
  "local": "mce6561a28_local",
  "toast": "mce6561a28_toast",
  "critical": "mce6561a28_critical",
  "info": "mce6561a28_info",
  "success": "mce6561a28_success",
  "warning": "mce6561a28_warning"
};
var alertPanel$1 = "mce6561a28_dls-typography-desktop-body-reg-medium mce6561a28_alertPanel";
var local = "mce6561a28_local";
var toast = "mce6561a28_toast";
var critical = "mce6561a28_critical";
var info = "mce6561a28_info";
var success = "mce6561a28_success";
var warning = "mce6561a28_warning";
var styles = ".mce6561a28_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}:host{display:block}dls-alert-panel{display:block}[data-style]{display:none}.mce6561a28_alertPanel{background:#fff;border:0 solid transparent;box-sizing:border-box;color:#3e3939;display:block}.mce6561a28_alertPanel.mce6561a28_local{border-color:#e0e3e4;border-radius:2px;border-width:1px 1px 1px 8px;padding:20px}.mce6561a28_alertPanel.mce6561a28_toast{border-color:#e0e3e4;border-left-width:8px;border-radius:4px;box-shadow:0 8px 24px 0 rgba(0,0,0,.12);padding:24px 16px}@media screen and (min-width:0) and (max-width:480px),screen and (min-width:481px) and (max-width:767px){.mce6561a28_alertPanel.mce6561a28_toast{padding:20px 12px}}:host([status=critical]){--alert-accent-color:#f76056}.mce6561a28_alertPanel.mce6561a28_critical{border-left-color:#f76056}:host([status=info]){--alert-accent-color:#566fb8}.mce6561a28_alertPanel.mce6561a28_info{border-left-color:#566fb8}:host([status=success]){--alert-accent-color:#7bc99d}.mce6561a28_alertPanel.mce6561a28_success{border-left-color:#7bc99d}:host([status=warning]){--alert-accent-color:#d6ae3e}.mce6561a28_alertPanel.mce6561a28_warning{border-left-color:#d6ae3e}";
var alertPanelStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': alertPanel,
  alertPanel: alertPanel$1,
  local: local,
  toast: toast,
  critical: critical,
  info: info,
  success: success,
  warning: warning,
  styles: styles
});
var panelHead = "mc7ad732a6_panelHead";
var panelName = "mc7ad732a6_dls-typography-desktop-body-bold-medium mc7ad732a6_panelName";
var styles$1 = ".mc7ad732a6_dls-typography-desktop-body-bold-medium{font-family:Lab Grotesque,sans-serif;font-weight:700;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc7ad732a6_panelName{margin:0}.mc7ad732a6_panelFoot{padding-top:32px}";

function create_fragment(ctx) {
  var dls_panel;
  var div;
  var t0;
  var slot0;
  var t1;
  var slot1;
  var t2;
  var slot2;
  var t3;
  var slot3;
  var dls_panel_class_value;
  return {
    c: function c() {
      dls_panel = element("dls-panel");
      div = element("div");
      t0 = space();
      slot0 = element("slot");
      t1 = space();
      slot1 = element("slot");
      t2 = space();
      slot2 = element("slot");
      t3 = space();
      slot3 = element("slot");
      this.c = noop;
      attr(div, "data-style", "");
      attr(slot0, "name", "alert-panel-head");
      attr(slot0, "slot", "panel-head");
      attr(slot1, "name", "alert-panel-body");
      attr(slot1, "slot", "panel-body");
      attr(slot2, "slot", "panel-body");
      attr(slot3, "name", "alert-panel-foot");
      attr(slot3, "slot", "panel-foot");
      set_custom_element_data(dls_panel, "role", "alert");
      set_custom_element_data(dls_panel, "class", dls_panel_class_value = "" + (
      /*style*/
      ctx[4].is("alertPanel") + " " +
      /*style*/
      ctx[4].is(
      /*status*/
      ctx[1]) + " " +
      /*style*/
      ctx[4].is(
      /*type*/
      ctx[2])));
      set_custom_element_data(dls_panel, "name",
      /*name*/
      ctx[0]);
      set_custom_element_data(dls_panel, "theme", "alert");
    },
    m: function m(target, anchor) {
      insert(target, dls_panel, anchor);
      append(dls_panel, div);
      div.innerHTML =
      /*stylesheet*/
      ctx[3];
      append(dls_panel, t0);
      append(dls_panel, slot0);
      append(dls_panel, t1);
      append(dls_panel, slot1);
      append(dls_panel, t2);
      append(dls_panel, slot2);
      append(dls_panel, t3);
      append(dls_panel, slot3);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*status, type*/
      6 && dls_panel_class_value !== (dls_panel_class_value = "" + (
      /*style*/
      ctx[4].is("alertPanel") + " " +
      /*style*/
      ctx[4].is(
      /*status*/
      ctx[1]) + " " +
      /*style*/
      ctx[4].is(
      /*type*/
      ctx[2])))) {
        set_custom_element_data(dls_panel, "class", dls_panel_class_value);
      }

      if (dirty &
      /*name*/
      1) {
        set_custom_element_data(dls_panel, "name",
        /*name*/
        ctx[0]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(dls_panel);
    }
  };
}

function instance($$self, $$props, $$invalidate) {
  var stylesheet = "<style>".concat(styles, "</style>");
  var style = new StyleUtilities(alertPanelStyles);
  DlsPanel.addStyles([{
    attributeName: "theme",
    attributeValue: "alert",
    className: "ignore",
    styles: styles$1,
    parts: {
      panelHead: panelHead,
      panelName: panelName
    }
  }]);
  var _$$props$name = $$props.name,
      name = _$$props$name === void 0 ? "" : _$$props$name;
  var _$$props$status = $$props.status,
      status = _$$props$status === void 0 ? "" : _$$props$status;
  var _$$props$type = $$props.type,
      type = _$$props$type === void 0 ? "" : _$$props$type;

  $$self.$set = function ($$props) {
    if ("name" in $$props) $$invalidate(0, name = $$props.name);
    if ("status" in $$props) $$invalidate(1, status = $$props.status);
    if ("type" in $$props) $$invalidate(2, type = $$props.type);
  };

  return [name, status, type, stylesheet, style];
}

var DlsAlerts =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsAlerts, _SvelteElement);

  function DlsAlerts(options) {
    var _this;

    _classCallCheck(this, DlsAlerts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsAlerts).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {
      name: 0,
      status: 1,
      type: 2
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsAlerts, [{
    key: "name",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(name) {
      this.$set({
        name: name
      });
      flush();
    }
  }, {
    key: "status",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(status) {
      this.$set({
        status: status
      });
      flush();
    }
  }, {
    key: "type",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(type) {
      this.$set({
        type: type
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["name", "status", "type"];
    }
  }]);

  return DlsAlerts;
}(SvelteElement);

var localAlert = {
  "dls-typography-desktop-body-bold-medium": "mcfe52c135_dls-typography-desktop-body-bold-medium",
  "dls-typography-desktop-body-reg-medium": "mcfe52c135_dls-typography-desktop-body-reg-medium",
  "localAlert": "mcfe52c135_localAlert",
  "hidden": "mcfe52c135_hidden",
  "localAlertBody": "mcfe52c135_localAlertBody",
  "localAlertMessage": "mcfe52c135_localAlertMessage",
  "localAlertDismiss": "mcfe52c135_localAlertDismiss",
  "dismissible": "mcfe52c135_dismissible",
  "localAlertDismissGlyph": "mcfe52c135_localAlertDismissGlyph",
  "localAlertMessageGlyph": "mcfe52c135_localAlertMessageGlyph",
  "critical": "mcfe52c135_critical",
  "info": "mcfe52c135_info",
  "success": "mcfe52c135_success",
  "warning": "mcfe52c135_warning",
  "localAlertMessageText": "mcfe52c135_localAlertMessageText",
  "regular": "mcfe52c135_dls-typography-desktop-body-reg-medium mcfe52c135_regular",
  "bold": "mcfe52c135_dls-typography-desktop-body-bold-medium mcfe52c135_bold"
};
var localAlert$1 = "mcfe52c135_localAlert";
var hidden = "mcfe52c135_hidden";
var localAlertBody = "mcfe52c135_localAlertBody";
var localAlertMessage = "mcfe52c135_localAlertMessage";
var localAlertDismiss = "mcfe52c135_localAlertDismiss";
var dismissible = "mcfe52c135_dismissible";
var localAlertDismissGlyph = "mcfe52c135_localAlertDismissGlyph";
var localAlertMessageGlyph = "mcfe52c135_localAlertMessageGlyph";
var critical$1 = "mcfe52c135_critical";
var info$1 = "mcfe52c135_info";
var success$1 = "mcfe52c135_success";
var warning$1 = "mcfe52c135_warning";
var localAlertMessageText = "mcfe52c135_localAlertMessageText";
var regular = "mcfe52c135_dls-typography-desktop-body-reg-medium mcfe52c135_regular";
var bold = "mcfe52c135_dls-typography-desktop-body-bold-medium mcfe52c135_bold";
var styles$2 = ".mcfe52c135_dls-typography-desktop-body-bold-medium{font-family:Lab Grotesque,sans-serif;font-weight:700;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mcfe52c135_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}:host{display:block}dls-local-alert{display:block}[data-style]{display:none}.mcfe52c135_localAlert{overflow:hidden;transition:opacity .3s ease-out 0ms,max-height .3s linear 0ms}.mcfe52c135_localAlert:not(.mcfe52c135_hidden){max-height:450px;opacity:1}.mcfe52c135_localAlert.mcfe52c135_hidden{max-height:0;opacity:0}.mcfe52c135_localAlertBody{align-items:flex-start;display:flex;justify-content:space-between}.mcfe52c135_localAlert,.mcfe52c135_localAlertMessage{display:block}.mcfe52c135_localAlertDismiss{background:none transparent;border:0;color:#999;cursor:pointer;display:none;flex:0 0 auto;font:inherit;margin:-20px -20px -20px 0;padding:20px 20px 20px 0}.mcfe52c135_localAlertDismiss:focus{outline:0}.mcfe52c135_localAlertDismiss.mcfe52c135_dismissible{display:block}.mcfe52c135_localAlertDismissGlyph{display:block;padding-left:24px}.mcfe52c135_localAlertMessage{align-items:flex-start;display:flex;flex:1 1 0%;justify-content:flex-start}.mcfe52c135_localAlertMessageGlyph{flex:0 0 auto;order:-1}:host([status=critical]){--alert-text-color:#d1352a}.mcfe52c135_localAlertMessageGlyph.mcfe52c135_critical{color:#d1352a}:host([status=info]){--alert-text-color:#3b4e85}.mcfe52c135_localAlertMessageGlyph.mcfe52c135_info{color:#3b4e85}:host([status=success]){--alert-text-color:#2d8560}.mcfe52c135_localAlertMessageGlyph.mcfe52c135_success{color:#2d8560}:host([status=warning]){--alert-text-color:#b36104}.mcfe52c135_localAlertMessageGlyph.mcfe52c135_warning{color:#b36104}.mcfe52c135_localAlertMessageText{flex:1 1 0%;margin-left:12px;order:0}";
var localAlertStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': localAlert,
  localAlert: localAlert$1,
  hidden: hidden,
  localAlertBody: localAlertBody,
  localAlertMessage: localAlertMessage,
  localAlertDismiss: localAlertDismiss,
  dismissible: dismissible,
  localAlertDismissGlyph: localAlertDismissGlyph,
  localAlertMessageGlyph: localAlertMessageGlyph,
  critical: critical$1,
  info: info$1,
  success: success$1,
  warning: warning$1,
  localAlertMessageText: localAlertMessageText,
  regular: regular,
  bold: bold,
  styles: styles$2
});

function create_if_block_3(ctx) {
  var dls_icon_triangle_exclamation;
  return {
    c: function c() {
      dls_icon_triangle_exclamation = element("dls-icon-triangle-exclamation");
      set_custom_element_data(dls_icon_triangle_exclamation, "class",
      /*glyphClassNames*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_triangle_exclamation, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*glyphClassNames*/
      16) {
        set_custom_element_data(dls_icon_triangle_exclamation, "class",
        /*glyphClassNames*/
        ctx[4]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(dls_icon_triangle_exclamation);
    }
  };
} // (17:39) 


function create_if_block_2(ctx) {
  var dls_icon_circle_check;
  return {
    c: function c() {
      dls_icon_circle_check = element("dls-icon-circle-check");
      set_custom_element_data(dls_icon_circle_check, "class",
      /*glyphClassNames*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_circle_check, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*glyphClassNames*/
      16) {
        set_custom_element_data(dls_icon_circle_check, "class",
        /*glyphClassNames*/
        ctx[4]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(dls_icon_circle_check);
    }
  };
} // (15:36) 


function create_if_block_1(ctx) {
  var dls_icon_lightbulb;
  return {
    c: function c() {
      dls_icon_lightbulb = element("dls-icon-lightbulb");
      set_custom_element_data(dls_icon_lightbulb, "class",
      /*glyphClassNames*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_lightbulb, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*glyphClassNames*/
      16) {
        set_custom_element_data(dls_icon_lightbulb, "class",
        /*glyphClassNames*/
        ctx[4]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(dls_icon_lightbulb);
    }
  };
} // (13:8) {#if status === 'critical'}


function create_if_block(ctx) {
  var dls_icon_circle_x;
  return {
    c: function c() {
      dls_icon_circle_x = element("dls-icon-circle-x");
      set_custom_element_data(dls_icon_circle_x, "class",
      /*glyphClassNames*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_circle_x, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*glyphClassNames*/
      16) {
        set_custom_element_data(dls_icon_circle_x, "class",
        /*glyphClassNames*/
        ctx[4]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(dls_icon_circle_x);
    }
  };
}

function create_fragment$1(ctx) {
  var dls_alert_panel;
  var div0;
  var t0;
  var div3;
  var div2;
  var slot0;
  var t1;
  var div1;
  var slot1;
  var t2;
  var t3;
  var slot2;
  var div1_class_value;
  var div2_class_value;
  var t4;
  var button;
  var dls_icon_close;
  var dls_icon_close_class_value;
  var button_class_value;
  var div3_class_value;
  var dls_alert_panel_class_value;
  var dispose;

  function select_block_type(ctx, dirty) {
    if (
    /*status*/
    ctx[3] === "critical") return create_if_block;
    if (
    /*status*/
    ctx[3] === "info") return create_if_block_1;
    if (
    /*status*/
    ctx[3] === "success") return create_if_block_2;
    if (
    /*status*/
    ctx[3] === "warning") return create_if_block_3;
  }

  var current_block_type = select_block_type(ctx);
  var if_block = current_block_type && current_block_type(ctx);
  return {
    c: function c() {
      dls_alert_panel = element("dls-alert-panel");
      div0 = element("div");
      t0 = space();
      div3 = element("div");
      div2 = element("div");
      slot0 = element("slot");
      if (if_block) if_block.c();
      t1 = space();
      div1 = element("div");
      slot1 = element("slot");
      t2 = text(
      /*formattedText*/
      ctx[5]);
      t3 = space();
      slot2 = element("slot");
      t4 = space();
      button = element("button");
      dls_icon_close = element("dls-icon-close");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(slot0, "name", "local-alert-glyph");
      attr(slot1, "name", "local-alert-text");
      attr(div1, "class", div1_class_value = "" + (
      /*style*/
      ctx[7].is("localAlertMessageText") + " " +
      /*style*/
      ctx[7].or("bold", "regular",
      /*bold*/
      ctx[0])));
      attr(div2, "class", div2_class_value =
      /*style*/
      ctx[7].is("localAlertMessage"));
      set_custom_element_data(dls_icon_close, "class", dls_icon_close_class_value =
      /*style*/
      ctx[7].is("localAlertDismissGlyph"));
      attr(button, "class", button_class_value = "" + (
      /*style*/
      ctx[7].is("localAlertDismiss") + " " +
      /*style*/
      ctx[7].if("dismissible",
      /*dismissible*/
      ctx[1])));
      attr(div3, "class", div3_class_value =
      /*style*/
      ctx[7].is("localAlertBody"));
      attr(div3, "slot", "alert-panel-body");
      set_custom_element_data(dls_alert_panel, "class", dls_alert_panel_class_value = "" + (
      /*style*/
      ctx[7].is("localAlert") + " " +
      /*style*/
      ctx[7].if("hidden",
      /*hidden*/
      ctx[2])));
      set_custom_element_data(dls_alert_panel, "status",
      /*status*/
      ctx[3]);
      set_custom_element_data(dls_alert_panel, "type", "local");
    },
    m: function m(target, anchor) {
      insert(target, dls_alert_panel, anchor);
      append(dls_alert_panel, div0);
      div0.innerHTML =
      /*stylesheet*/
      ctx[6];
      append(dls_alert_panel, t0);
      append(dls_alert_panel, div3);
      append(div3, div2);
      append(div2, slot0);
      if (if_block) if_block.m(slot0, null);
      append(div2, t1);
      append(div2, div1);
      append(div1, slot1);
      append(slot1, t2);
      append(div1, t3);
      append(div1, slot2);
      append(div3, t4);
      append(div3, button);
      append(button, dls_icon_close);
      dispose = listen(button, "click", dismiss);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
        if_block.p(ctx, dirty);
      } else {
        if (if_block) if_block.d(1);
        if_block = current_block_type && current_block_type(ctx);

        if (if_block) {
          if_block.c();
          if_block.m(slot0, null);
        }
      }

      if (dirty &
      /*formattedText*/
      32) set_data(t2,
      /*formattedText*/
      ctx[5]);

      if (dirty &
      /*bold*/
      1 && div1_class_value !== (div1_class_value = "" + (
      /*style*/
      ctx[7].is("localAlertMessageText") + " " +
      /*style*/
      ctx[7].or("bold", "regular",
      /*bold*/
      ctx[0])))) {
        attr(div1, "class", div1_class_value);
      }

      if (dirty &
      /*dismissible*/
      2 && button_class_value !== (button_class_value = "" + (
      /*style*/
      ctx[7].is("localAlertDismiss") + " " +
      /*style*/
      ctx[7].if("dismissible",
      /*dismissible*/
      ctx[1])))) {
        attr(button, "class", button_class_value);
      }

      if (dirty &
      /*hidden*/
      4 && dls_alert_panel_class_value !== (dls_alert_panel_class_value = "" + (
      /*style*/
      ctx[7].is("localAlert") + " " +
      /*style*/
      ctx[7].if("hidden",
      /*hidden*/
      ctx[2])))) {
        set_custom_element_data(dls_alert_panel, "class", dls_alert_panel_class_value);
      }

      if (dirty &
      /*status*/
      8) {
        set_custom_element_data(dls_alert_panel, "status",
        /*status*/
        ctx[3]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(dls_alert_panel);

      if (if_block) {
        if_block.d();
      }

      dispose();
    }
  };
}

function dismiss(event) {
  var hostElement = event.composedPath().filter(function (el) {
    return Boolean(el.tagName === "DLS-LOCAL-ALERT");
  }).shift();
  hostElement.setAttribute("hidden", "hidden");
}

function instance$1($$self, $$props, $$invalidate) {
  var stylesheet = "<style>".concat(styles$2, "</style>");
  var style = new StyleUtilities(localAlertStyles);
  var _$$props$bold = $$props.bold,
      bold = _$$props$bold === void 0 ? false : _$$props$bold; // TODO: build in or compose in?

  var _$$props$dismissible = $$props.dismissible,
      dismissible = _$$props$dismissible === void 0 ? false : _$$props$dismissible;
  var _$$props$hidden = $$props.hidden,
      hidden = _$$props$hidden === void 0 ? false : _$$props$hidden;
  var _$$props$status = $$props.status,
      status = _$$props$status === void 0 ? "info" : _$$props$status;
  var _$$props$text = $$props.text,
      text = _$$props$text === void 0 ? "" : _$$props$text;

  $$self.$set = function ($$props) {
    if ("bold" in $$props) $$invalidate(0, bold = $$props.bold);
    if ("dismissible" in $$props) $$invalidate(1, dismissible = $$props.dismissible);
    if ("hidden" in $$props) $$invalidate(2, hidden = $$props.hidden);
    if ("status" in $$props) $$invalidate(3, status = $$props.status);
    if ("text" in $$props) $$invalidate(8, text = $$props.text);
  };

  var glyphClassNames;
  var hasText;
  var formattedText;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*status*/
    8) {
      // TODO: after toast, make breaking changes to support theming?
      // export let theme = '';
      // TODO: after toast, make breaking changes to support glyph?
      // $: hasGlyph = Boolean(glyph && typeof glyph === 'string' && glyph.length);
      $$invalidate(4, glyphClassNames = style.are("localAlertMessageGlyph", status));
    }

    if ($$self.$$.dirty &
    /*text*/
    256) {
      // $: formattedGlyph = hasGlyph
      //   ? `<dls-icon-${glyph} class="${glyphClassNames}"></dls-icon-${glyph}>`
      //   : '';
      $$invalidate(9, hasText = Boolean(text && typeof text === "string" && text.length));
    }

    if ($$self.$$.dirty &
    /*hasText, text*/
    768) {
      $$invalidate(5, formattedText = hasText ? text : "");
    }
  };

  return [bold, dismissible, hidden, status, glyphClassNames, formattedText, stylesheet, style, text];
}

var DlsAlerts$1 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsAlerts, _SvelteElement);

  function DlsAlerts(options) {
    var _this;

    _classCallCheck(this, DlsAlerts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsAlerts).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$1, create_fragment$1, safe_not_equal, {
      bold: 0,
      dismissible: 1,
      hidden: 2,
      status: 3,
      text: 8
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsAlerts, [{
    key: "bold",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(bold) {
      this.$set({
        bold: bold
      });
      flush();
    }
  }, {
    key: "dismissible",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(dismissible) {
      this.$set({
        dismissible: dismissible
      });
      flush();
    }
  }, {
    key: "hidden",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(hidden) {
      this.$set({
        hidden: hidden
      });
      flush();
    }
  }, {
    key: "status",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(status) {
      this.$set({
        status: status
      });
      flush();
    }
  }, {
    key: "text",
    get: function get() {
      return this.$$.ctx[8];
    },
    set: function set(text) {
      this.$set({
        text: text
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["bold", "dismissible", "hidden", "status", "text"];
    }
  }]);

  return DlsAlerts;
}(SvelteElement);

var toastAlert = {
  "dls-typography-desktop-body-bold-medium": "mcb6325db8_dls-typography-desktop-body-bold-medium",
  "dls-typography-desktop-body-reg-medium": "mcb6325db8_dls-typography-desktop-body-reg-medium",
  "toastAlert": "mcb6325db8_toastAlert",
  "queued": "mcb6325db8_queued",
  "exitAnimation": "mcb6325db8_exitAnimation",
  "toastAlertFoot": "mcb6325db8_toastAlertFoot",
  "toastAlertDismiss": "mcb6325db8_toastAlertDismiss",
  "toastAlertBody": "mcb6325db8_toastAlertBody",
  "toastAlertMessage": "mcb6325db8_toastAlertMessage",
  "toastAlertHead": "mcb6325db8_dls-typography-desktop-body-bold-medium mcb6325db8_toastAlertHead",
  "toastAlertDismissGlyph": "mcb6325db8_toastAlertDismissGlyph",
  "toastAlertMessageGlyph": "mcb6325db8_toastAlertMessageGlyph",
  "critical": "mcb6325db8_critical",
  "info": "mcb6325db8_info",
  "success": "mcb6325db8_success",
  "warning": "mcb6325db8_warning",
  "toastAlertMessageText": "mcb6325db8_toastAlertMessageText",
  "empty": "mcb6325db8_empty"
};
var toastAlert$1 = "mcb6325db8_toastAlert";
var queued = "mcb6325db8_queued";
var exitAnimation = "mcb6325db8_exitAnimation";
var toastAlertFoot = "mcb6325db8_toastAlertFoot";
var toastAlertDismiss = "mcb6325db8_toastAlertDismiss";
var toastAlertBody = "mcb6325db8_toastAlertBody";
var toastAlertMessage = "mcb6325db8_toastAlertMessage";
var toastAlertHead = "mcb6325db8_dls-typography-desktop-body-bold-medium mcb6325db8_toastAlertHead";
var toastAlertDismissGlyph = "mcb6325db8_toastAlertDismissGlyph";
var toastAlertMessageGlyph = "mcb6325db8_toastAlertMessageGlyph";
var critical$2 = "mcb6325db8_critical";
var info$2 = "mcb6325db8_info";
var success$2 = "mcb6325db8_success";
var warning$2 = "mcb6325db8_warning";
var toastAlertMessageText = "mcb6325db8_toastAlertMessageText";
var empty$1 = "mcb6325db8_empty";
var styles$3 = ".mcb6325db8_dls-typography-desktop-body-bold-medium{font-family:Lab Grotesque,sans-serif;font-weight:700;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mcb6325db8_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}:host{display:block}dls-toast-alert{display:block}[data-style]{display:none}@keyframes mcb6325db8_desktopEnter{0%{transform:translateX(100%) translateZ(0)}to{transform:translateX(0) translateZ(0)}}@keyframes mcb6325db8_mobileEnter{0%{transform:translateY(100%) translateZ(0)}to{transform:translateY(0) translateZ(0)}}@keyframes mcb6325db8_exitSlide{0%{transform:translateX(0) translateZ(0)}to{transform:translateX(100%) translateZ(0)}}@keyframes mcb6325db8_exitFade{0%{opacity:1}to{opacity:0}}@keyframes mcb6325db8_desktopShrink{0%{margin-top:12px}to{margin-top:0}}@keyframes mcb6325db8_mobileShrink{0%{margin-bottom:12px}to{margin-bottom:0}}.mcb6325db8_toastAlert.mcb6325db8_queued{position:absolute;transform:translateX(120%);z-index:2}@media screen and (min-width:768px) and (max-width:1023px),screen and (min-width:1024px) and (max-width:1279px),screen and (min-width:1280px) and (max-width:1439px),screen and (min-width:1440px) and (max-width:1823px),screen and (min-width:1824px){.mcb6325db8_toastAlert{animation:mcb6325db8_desktopEnter .3s ease-out forwards;margin-top:12px;width:345px}.mcb6325db8_toastAlert.mcb6325db8_exitAnimation{animation:mcb6325db8_exitSlide .5s ease-out 0s forwards,mcb6325db8_exitFade .3s ease-out .2s forwards,mcb6325db8_desktopShrink .2s ease-out .5s forwards}}@media screen and (min-width:0) and (max-width:480px),screen and (min-width:481px) and (max-width:767px){.mcb6325db8_toastAlert{animation:mcb6325db8_mobileEnter .3s ease-out forwards;margin-bottom:12px;max-width:345px;min-width:288px}.mcb6325db8_toastAlert.mcb6325db8_exitAnimation{animation:mcb6325db8_exitSlide .5s ease-out 0s forwards,mcb6325db8_exitFade .3s ease-out .2s forwards,mcb6325db8_mobileShrink .2s ease-out .5s forwards}}.mcb6325db8_toastAlert,.mcb6325db8_toastAlertBody,.mcb6325db8_toastAlertDismiss,.mcb6325db8_toastAlertFoot,.mcb6325db8_toastAlertMessage{display:block}.mcb6325db8_toastAlertDismiss{background:none transparent;border:0;color:#999;cursor:pointer;flex:0 0 auto;font:inherit;position:relative;z-index:2;margin:-24px -16px -24px 0;padding:12px 12px 24px 0}.mcb6325db8_toastAlertHead{align-items:flex-start;display:flex;justify-content:space-between;position:relative;z-index:2}.mcb6325db8_toastAlertDismiss:focus{outline:0}.mcb6325db8_toastAlertDismissGlyph{display:block;padding-left:24px}.mcb6325db8_toastAlertMessage{align-items:flex-start;display:flex;flex:1 1 0%;justify-content:flex-start}.mcb6325db8_toastAlertMessageGlyph{flex:0 0 auto;order:-1}.mcb6325db8_toastAlertMessageGlyph.mcb6325db8_critical{color:#d1352a}.mcb6325db8_toastAlertMessageGlyph.mcb6325db8_info{color:#3b4e85}.mcb6325db8_toastAlertMessageGlyph.mcb6325db8_success{color:#2d8560}.mcb6325db8_toastAlertMessageGlyph.mcb6325db8_warning{color:#b36104}.mcb6325db8_toastAlertMessageText{flex:1 1 0%;margin-left:12px;order:0}.mcb6325db8_toastAlertBody,.mcb6325db8_toastAlertFoot{margin-top:12px;padding-left:36px;padding-right:28px}.mcb6325db8_empty{display:none}";
var toastAlertStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': toastAlert,
  toastAlert: toastAlert$1,
  queued: queued,
  exitAnimation: exitAnimation,
  toastAlertFoot: toastAlertFoot,
  toastAlertDismiss: toastAlertDismiss,
  toastAlertBody: toastAlertBody,
  toastAlertMessage: toastAlertMessage,
  toastAlertHead: toastAlertHead,
  toastAlertDismissGlyph: toastAlertDismissGlyph,
  toastAlertMessageGlyph: toastAlertMessageGlyph,
  critical: critical$2,
  info: info$2,
  success: success$2,
  warning: warning$2,
  toastAlertMessageText: toastAlertMessageText,
  empty: empty$1,
  styles: styles$3
});

function create_if_block$1(ctx) {
  var dls_alert_panel;
  var div0;
  var t0;
  var div3;
  var div2;
  var html_tag;
  var t1;
  var div1;
  var slot0;
  var t2;
  var t3;
  var slot1;
  var div1_class_value;
  var div2_class_value;
  var t4;
  var button;
  var dls_icon_close;
  var dls_icon_close_class_value;
  var button_class_value;
  var div3_class_value;
  var t5;
  var div4;
  var slot2;
  var div4_class_value;
  var t6;
  var div5;
  var slot3;
  var div5_class_value;
  var dls_alert_panel_class_value;
  var dls_alert_panel_intro;
  var dls_alert_panel_outro;
  var current;
  var dispose;
  return {
    c: function c() {
      dls_alert_panel = element("dls-alert-panel");
      div0 = element("div");
      t0 = space();
      div3 = element("div");
      div2 = element("div");
      t1 = space();
      div1 = element("div");
      slot0 = element("slot");
      t2 = text(
      /*formattedText*/
      ctx[6]);
      t3 = space();
      slot1 = element("slot");
      t4 = space();
      button = element("button");
      dls_icon_close = element("dls-icon-close");
      t5 = space();
      div4 = element("div");
      slot2 = element("slot");
      t6 = space();
      div5 = element("div");
      slot3 = element("slot");
      attr(div0, "data-style", "");
      html_tag = new HtmlTag(
      /*formattedGlyph*/
      ctx[5], t1);
      attr(slot0, "name", "toast-alert-text");
      attr(div1, "class", div1_class_value = "" + (
      /*style*/
      ctx[8].is("toastAlertMessageText") + " " +
      /*style*/
      ctx[8].is("bold")));
      attr(div2, "class", div2_class_value =
      /*style*/
      ctx[8].is("toastAlertMessage"));
      set_custom_element_data(dls_icon_close, "class", dls_icon_close_class_value =
      /*style*/
      ctx[8].is("toastAlertDismissGlyph"));
      attr(button, "class", button_class_value =
      /*style*/
      ctx[8].is("toastAlertDismiss"));
      attr(div3, "class", div3_class_value =
      /*style*/
      ctx[8].is("toastAlertHead"));
      attr(div3, "slot", "alert-panel-head");
      attr(slot2, "name", "toast-alert-body");
      attr(div4, "class", div4_class_value =
      /*style*/
      ctx[8].are("toastAlertBody", "empty"));
      attr(div4, "slot", "alert-panel-body");
      attr(slot3, "name", "toast-alert-foot");
      attr(div5, "class", div5_class_value =
      /*style*/
      ctx[8].are("toastAlertFoot", "empty"));
      attr(div5, "slot", "alert-panel-foot");
      set_custom_element_data(dls_alert_panel, "class", dls_alert_panel_class_value = "" + (
      /*style*/
      ctx[8].is("toastAlert") + " " +
      /*style*/
      ctx[8].if("exitAnimation",
      /*isExiting*/
      ctx[3]) + " " +
      /*style*/
      ctx[8].if("queued",
      /*isQueued*/
      ctx[2])));
      set_custom_element_data(dls_alert_panel, "status",
      /*status*/
      ctx[0]);
      set_custom_element_data(dls_alert_panel, "role", "alert");
      set_custom_element_data(dls_alert_panel, "aria-live", "polite");
      set_custom_element_data(dls_alert_panel, "type", "toast");
    },
    m: function m(target, anchor) {
      insert(target, dls_alert_panel, anchor);
      append(dls_alert_panel, div0);
      div0.innerHTML =
      /*stylesheet*/
      ctx[7];
      append(dls_alert_panel, t0);
      append(dls_alert_panel, div3);
      append(div3, div2);
      html_tag.m(div2);
      append(div2, t1);
      append(div2, div1);
      append(div1, slot0);
      append(slot0, t2);
      append(div1, t3);
      append(div1, slot1);
      append(div3, t4);
      append(div3, button);
      append(button, dls_icon_close);
      append(dls_alert_panel, t5);
      append(dls_alert_panel, div4);
      append(div4, slot2);
      append(dls_alert_panel, t6);
      append(dls_alert_panel, div5);
      append(div5, slot3);
      /*dls_alert_panel_binding*/

      ctx[31](dls_alert_panel);
      current = true;
      dispose = [listen(button, "click",
      /*dismiss*/
      ctx[13]), listen(slot2, "slotchange",
      /*checkForSlotted*/
      ctx[9]), listen(slot3, "slotchange",
      /*checkForFootContents*/
      ctx[10]), listen(dls_alert_panel, "animationend",
      /*handleAnimationEnd*/
      ctx[14]), listen(dls_alert_panel, "introend",
      /*handleShownBehavior*/
      ctx[12]), listen(dls_alert_panel, "outroend",
      /*handleCleanup*/
      ctx[15])];
    },
    p: function p(ctx, dirty) {
      if (!current || dirty[0] &
      /*formattedGlyph*/
      32) html_tag.p(
      /*formattedGlyph*/
      ctx[5]);
      if (!current || dirty[0] &
      /*formattedText*/
      64) set_data(t2,
      /*formattedText*/
      ctx[6]);

      if (!current || dirty[0] &
      /*isExiting, isQueued*/
      12 && dls_alert_panel_class_value !== (dls_alert_panel_class_value = "" + (
      /*style*/
      ctx[8].is("toastAlert") + " " +
      /*style*/
      ctx[8].if("exitAnimation",
      /*isExiting*/
      ctx[3]) + " " +
      /*style*/
      ctx[8].if("queued",
      /*isQueued*/
      ctx[2])))) {
        set_custom_element_data(dls_alert_panel, "class", dls_alert_panel_class_value);
      }

      if (!current || dirty[0] &
      /*status*/
      1) {
        set_custom_element_data(dls_alert_panel, "status",
        /*status*/
        ctx[0]);
      }
    },
    i: function i(local) {
      if (current) return;
      add_render_callback(function () {
        if (dls_alert_panel_outro) dls_alert_panel_outro.end(1);
        if (!dls_alert_panel_intro) dls_alert_panel_intro = create_in_transition(dls_alert_panel,
        /*grow*/
        ctx[11], {});
        dls_alert_panel_intro.start();
      });
      current = true;
    },
    o: function o(local) {
      if (dls_alert_panel_intro) dls_alert_panel_intro.invalidate();
      dls_alert_panel_outro = create_out_transition(dls_alert_panel, shrink, {});
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(dls_alert_panel);
      /*dls_alert_panel_binding*/

      ctx[31](null);
      if (detaching && dls_alert_panel_outro) dls_alert_panel_outro.end();
      run_all(dispose);
    }
  };
}

function create_fragment$2(ctx) {
  var if_block_anchor;
  var current;
  var if_block =
  /*visible*/
  ctx[1] && create_if_block$1(ctx);
  return {
    c: function c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
      this.c = noop;
    },
    m: function m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      if (
      /*visible*/
      ctx[1]) {
        if (if_block) {
          if_block.p(ctx, dirty);
          transition_in(if_block, 1);
        } else {
          if_block = create_if_block$1(ctx);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}

var DEFAULT_DURATION = 5;
var TOAST_GROW_DURATION = 300;
var TOAST_SHRINK_DURATION = 300;
/* triggered when visible = false removes toastAlert node | out:shrink */

function shrink(node) {
  return {
    duration: TOAST_SHRINK_DURATION,
    tick: function tick(step) {
      /* step transitions from 1 to 0 over the duration */
      var toastHeight = node.clientHeight;
      node.style.cssText = "height: ".concat(toastHeight * step, "px;");
    }
  };
}

function instance$2($$self, $$props, $$invalidate) {
  var stylesheet = "<style>".concat(styles$3, "</style>");
  var style = new StyleUtilities(toastAlertStyles);
  var checkForSlotted = getCheckForSlotted(style.is("empty"));
  var glyphMap = {
    critical: "dls-icon-circle-x",
    info: "dls-icon-lightbulb",
    success: "dls-icon-circle-check",
    warning: "dls-icon-triangle-exclamation"
  };
  var visible = false;
  var isQueued = true;
  var isExiting = false;
  var dismissTimeout, fullToastHeight, hostElement, toastElement;
  var _$$props$glyph = $$props.glyph,
      glyph = _$$props$glyph === void 0 ? "" : _$$props$glyph;
  var _$$props$shown = $$props.shown,
      shown = _$$props$shown === void 0 ? false : _$$props$shown;
  var _$$props$status = $$props.status,
      status = _$$props$status === void 0 ? "info" : _$$props$status;
  var _$$props$text = $$props.text,
      text = _$$props$text === void 0 ? "" : _$$props$text;
  var _$$props$duration = $$props.duration,
      duration = _$$props$duration === void 0 ? DEFAULT_DURATION : _$$props$duration;
  onDestroy(function () {
    clearTimeout(dismissTimeout);
  });

  function checkForFootContents(event) {
    /* TODO: possibly update when checkForSlotted gets more robust */
    var passAlongCheckForSlotted = checkForSlotted.bind(event.target);
    var slotted = event.target.assignedNodes({
      flatten: true
    });

    if (slotted.length) {
      $$invalidate(16, duration = 0);
    }

    passAlongCheckForSlotted(event);
  }

  function getFormattedGlyph(glyph, status) {
    if (glyphMap[status]) {
      glyph = glyphMap[status].replace("dls-icon-", "");
    }

    var glyphClassNames = style.are("toastAlertMessageGlyph", status);
    var hasGlyph = Boolean(glyph && typeof glyph === "string" && glyph.length);
    return hasGlyph ? "<dls-icon-".concat(glyph, " class=\"").concat(glyphClassNames, "\"></dls-icon-").concat(glyph, ">") : "";
  }

  function synchronizeShownAttributeWithInternals(hasShownAttribute) {
    if (hasShownAttribute) {
      $$invalidate(1, visible = true);
      $$invalidate(3, isExiting = false);
    } else if (visible === true) {
      /* play exit animation before hiding when shown is removed */
      $$invalidate(3, isExiting = true);
    }
  }
  /* triggered when visible = true adds toastAlert node | in:grow */


  function grow(node) {
    tick().then(function () {
      fullToastHeight = fullToastHeight || node.clientHeight;
    });
    return {
      duration: TOAST_GROW_DURATION,
      tick: function tick(step) {
        /* step transitions from 0 to 1 over the duration */
        if (fullToastHeight !== undefined) {
          node.style.cssText = "position: relative; height: ".concat(fullToastHeight * step, "px");
        }
      }
    };
  }
  /* triggered after grow | on:introend */


  function handleShownBehavior(event) {
    $$invalidate(2, isQueued = false);
    event.target.style.cssText = "";
    dispatchToastShownEvent();
    startTimeout();
  }

  function dispatchToastShownEvent() {
    hostElement.dispatchEvent(new CustomEvent("dls-toast-shown", {
      bubbles: true
    }));
  }

  function startTimeout(event) {
    if (formattedDuration === 0) {
      return;
    }

    dismissTimeout = window.setTimeout(dismiss, formattedDuration);
  }
  /* triggered by timeout or user dismissal */


  function dismiss() {
    $$invalidate(3, isExiting = true);
  }
  /* triggered by dismiss() or reactive ($:) shown block setting isExiting = true */


  function handleAnimationEnd(event) {
    if (!event.animationName.match(/exitSlide/)) {
      return false;
    }

    $$invalidate(1, visible = false);
    hostElement.removeAttribute("shown");
  }
  /* triggered after shrink | on:outroend */


  function handleCleanup() {
    clearTimeout(dismissTimeout);
    dispatchToastHiddenEvent();
    $$invalidate(2, isQueued = false);
    $$invalidate(3, isExiting = false);
  }

  function dispatchToastHiddenEvent() {
    hostElement.dispatchEvent(new CustomEvent("dls-toast-hidden", {
      bubbles: true
    }));
  }

  function dls_alert_panel_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $$invalidate(4, toastElement = $$value);
    });
  }

  $$self.$set = function ($$props) {
    if ("glyph" in $$props) $$invalidate(17, glyph = $$props.glyph);
    if ("shown" in $$props) $$invalidate(18, shown = $$props.shown);
    if ("status" in $$props) $$invalidate(0, status = $$props.status);
    if ("text" in $$props) $$invalidate(19, text = $$props.text);
    if ("duration" in $$props) $$invalidate(16, duration = $$props.duration);
  };

  var formattedGlyph;
  var hasText;
  var formattedText;
  var formattedDuration;

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*glyph, status*/
    131073) {
      // TODO: make breaking changes to support theming?
      // export let theme = '';
      $$invalidate(5, formattedGlyph = getFormattedGlyph(glyph, status));
    }

    if ($$self.$$.dirty[0] &
    /*text*/
    524288) {
      $$invalidate(23, hasText = Boolean(text && typeof text === "string" && text.length));
    }

    if ($$self.$$.dirty[0] &
    /*hasText, text*/
    8912896) {
      $$invalidate(6, formattedText = hasText ? text : "");
    }

    if ($$self.$$.dirty[0] &
    /*duration*/
    65536) {
      formattedDuration = parseFloat(duration) * 1000;
    }

    if ($$self.$$.dirty[0] &
    /*toastElement*/
    16) {
      if (toastElement) {
        hostElement = toastElement.parentNode.host;
      }
    }

    if ($$self.$$.dirty[0] &
    /*shown*/
    262144) {
      synchronizeShownAttributeWithInternals(shown);
    }
  };

  return [status, visible, isQueued, isExiting, toastElement, formattedGlyph, formattedText, stylesheet, style, checkForSlotted, checkForFootContents, grow, handleShownBehavior, dismiss, handleAnimationEnd, handleCleanup, duration, glyph, shown, text, dismissTimeout, fullToastHeight, hostElement, hasText, formattedDuration, glyphMap, getFormattedGlyph, synchronizeShownAttributeWithInternals, dispatchToastShownEvent, startTimeout, dispatchToastHiddenEvent, dls_alert_panel_binding];
}

var DlsAlerts$2 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsAlerts, _SvelteElement);

  function DlsAlerts(options) {
    var _this;

    _classCallCheck(this, DlsAlerts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsAlerts).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$2, create_fragment$2, safe_not_equal, {
      glyph: 17,
      shown: 18,
      status: 0,
      text: 19,
      duration: 16
    }, [-1, -1]);

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsAlerts, [{
    key: "glyph",
    get: function get() {
      return this.$$.ctx[17];
    },
    set: function set(glyph) {
      this.$set({
        glyph: glyph
      });
      flush();
    }
  }, {
    key: "shown",
    get: function get() {
      return this.$$.ctx[18];
    },
    set: function set(shown) {
      this.$set({
        shown: shown
      });
      flush();
    }
  }, {
    key: "status",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(status) {
      this.$set({
        status: status
      });
      flush();
    }
  }, {
    key: "text",
    get: function get() {
      return this.$$.ctx[19];
    },
    set: function set(text) {
      this.$set({
        text: text
      });
      flush();
    }
  }, {
    key: "duration",
    get: function get() {
      return this.$$.ctx[16];
    },
    set: function set(duration) {
      this.$set({
        duration: duration
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["glyph", "shown", "status", "text", "duration"];
    }
  }]);

  return DlsAlerts;
}(SvelteElement);

var elements = [{
  tagName: 'dls-alert-panel',
  customElement: DlsAlerts
}, {
  tagName: 'dls-local-alert',
  customElement: DlsAlerts$1
}, {
  tagName: 'dls-toast-alert',
  customElement: DlsAlerts$2
}];
elements.forEach(function (_ref) {
  var tagName = _ref.tagName,
      customElement = _ref.customElement; // TODO: create shared utility later
  // TODO: don't call by default later, will be breaking change

  try {
    window.customElements.define(tagName, customElement);
  } catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
  }
});
export { DlsAlerts as DlsAlertPanel, DlsAlerts$1 as DlsLocalAlert, DlsAlerts$2 as DlsToastAlert };